<script lang="ts">
	import {
		firstLoadedMargin,
		sumOfAllMarginsWithoutPositions,
		sumOfAllUserMargin,
		userMarginList
	} from '$lib/home/userInteract/store';
	import { openViewAllMarginModal } from '$lib/home/userInteract/userInteract';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import type { MarketIdentifiers } from '$lib/types/market';
	import type { UserMargin } from '$lib/types/user';
	import { addDollarSign, getNumBackInUnits, sortMarginsInDescending } from '$lib/util/util';
	import MarketMarginRow from './MarketMarginRow.svelte';

	interface UserMarginModified extends UserMargin {
		marketIdentifier: MarketIdentifiers;
	}
	let marginsInDescending: UserMarginModified[];
	$: if ($userMarginList) {
		marginsInDescending = sortMarginsInDescending($userMarginList) as UserMarginModified[];
	}
</script>

<div class="border border-fx-grey-500 w-full rounded-xl squircle-xl h-full p-3">
	<div class="flex flex-col">
		<div class="flex justify-between items-center">
			<Tooltip
				header="Margins without Active Positions"
				title="Total Margin that doesn't have any position in USD value"
			>
				<p class="text-fx-blue font-semibold text-lg">
					{#if $sumOfAllMarginsWithoutPositions}
						{addDollarSign(getNumBackInUnits($sumOfAllUserMargin, 18, 2))}
					{:else}
						<div>-</div>
					{/if}
				</p>
			</Tooltip>
			<img src={'new_sc_wallet/markets.svg'} loading="lazy" alt="new_sc_wallet/assets.svg" />
		</div>

		<div class="flex justify-between items-center">
			<p class="text-sm text-fx-grey-300">Margin Balance</p>
			<button
				on:click={() => {
					openViewAllMarginModal();
				}}
				on:keydown={() => {
					openViewAllMarginModal();
				}}
			>
				<p class="text-xs text-fx-pink underline underline-offset-2">View All</p>
			</button>
		</div>
	</div>
	<div class="border-t border-t-fx-grey-600 my-2" />
	<div class="flex flex-col gap-2 h-40 overflow-y-auto fx-scrollbar">
		{#if marginsInDescending && marginsInDescending.length > 0}
			{#each marginsInDescending as margin}
				<MarketMarginRow
					market={margin.marketIdentifier}
					balance={getNumBackInUnits(margin.depositedMargin, 18, 2)}
				/>
			{/each}
		{:else if marginsInDescending && marginsInDescending.length == 0}
			<div class="flex flex-col justify-center items-center h-full">
				<img src={'no-trades.webp'} loading="lazy" alt="static/no-trades.webp" class="w-36" />
				<div class="text-fx-grey-300 text-xs mt-2">No Unused Margins</div>
			</div>
		{:else}
			<div class="flex flex-col items-center w-full h-full justify-between">
				<div
					class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
				/>
				<div
					class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
				/>
				<div
					class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
				/>
			</div>
		{/if}
	</div>
</div>
